(function () {
  function arranca(raiz) {
    if (raiz.getAttribute("data-ak-listo") === "1") return;
    raiz.setAttribute("data-ak-listo", "1");

    var video = raiz.querySelector("video");
    var pista = raiz.querySelector("[data-ak-scroll-pista]");
    if (!video || !pista) return;

    video.controls = false;
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.preload = "none";
    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");
    video.removeAttribute("autoplay");
    video.removeAttribute("controls");

    var leyenda = raiz.querySelector("[data-ak-leyenda]");
    var frases = [];
    var nodoFrases = raiz.querySelector("[data-ak-frases]");
    if (nodoFrases) {
      try {
        frases = JSON.parse(nodoFrases.textContent || "[]");
      } catch (e) {
        frases = [];
      }
    }

    var vivo = false;
    var buscando = false;
    var pendiente = 0;
    var abierto = false;
    var cargado = false;
    var suave = 0;

    function progreso() {
      var rec = pista.getBoundingClientRect();
      var recorrido = pista.offsetHeight - window.innerHeight;
      if (recorrido < 8) recorrido = window.innerHeight * 1.8;
      return Math.min(1, Math.max(0, -rec.top / recorrido));
    }

    function frasesDe(pct) {
      for (var i = 0; i < frases.length; i++) {
        var f = frases[i];
        if (pct >= f.desde && pct < f.hasta) return f.texto || "";
      }
      if (pct >= 100 && frases.length) return frases[frases.length - 1].texto || "";
      return "";
    }

    function pintaFrase(pct) {
      if (!leyenda || !frases.length) return;
      var txt = frasesDe(pct);
      if (txt) {
        if (leyenda.textContent !== txt) leyenda.textContent = txt;
        leyenda.classList.add("is-on");
      } else {
        leyenda.classList.remove("is-on");
      }
    }

    function aplicar(t) {
      var dur = video.duration;
      if (!dur || !isFinite(dur)) return;
      var tope = Math.max(0, dur - 0.05);
      pendiente = Math.min(tope, Math.max(0, t));
      if (buscando) return;
      if (Math.abs(video.currentTime - pendiente) < 0.04) return;
      buscando = true;
      try {
        video.currentTime = pendiente;
      } catch (e) {
        buscando = false;
      }
    }

    function tick() {
      var rec = pista.getBoundingClientRect();
      if (rec.bottom < 0 || rec.top > window.innerHeight) {
        vivo = false;
        return;
      }
      var p = progreso();
      pintaFrase(p * 100);
      if (video.duration && isFinite(video.duration)) {
        // El vídeo no salta al punto exacto del scroll: se acerca a él poco a
        // poco en cada fotograma. En el móvil el dedo da tirones (y cada
        // búsqueda tarda), así el niño cae suave en vez de a saltos.
        var objetivo = p * video.duration;
        suave += (objetivo - suave) * 0.18;
        if (Math.abs(objetivo - suave) < 0.01) suave = objetivo;
        aplicar(suave);
      }
      requestAnimationFrame(tick);
    }

    function sigue() {
      if (vivo) return;
      vivo = true;
      requestAnimationFrame(tick);
    }

    function abreDecoder() {
      if (abierto || !cargado) return;
      video.muted = true;
      var p = video.play();
      if (p && typeof p.then === "function") {
        p.then(function () {
          video.pause();
          abierto = true;
          aplicar(progreso() * (video.duration || 0));
        }).catch(function () {});
      } else {
        abierto = true;
      }
    }

    function carga() {
      if (cargado) return;
      var url = video.getAttribute("data-src");
      if (!url) return;
      cargado = true;
      video.preload = "auto";
      video.src = url;
      video.load();
    }

    video.addEventListener("playing", function () {
      video.pause();
      abierto = true;
    });

    video.addEventListener("seeked", function () {
      buscando = false;
      if (Math.abs(video.currentTime - pendiente) > 0.04) aplicar(pendiente);
    });

    video.addEventListener("loadedmetadata", function () {
      suave = progreso() * (video.duration || 0);
      sigue();
      aplicar(suave);
    });

    video.addEventListener("canplay", function () {
      abreDecoder();
      sigue();
    });

    if ("IntersectionObserver" in window) {
      var cerca = new IntersectionObserver(function (entradas) {
        if (!entradas[0] || !entradas[0].isIntersecting) return;
        carga();
        cerca.disconnect();
      }, { rootMargin: "900px 0px" });
      cerca.observe(pista);

      var vista = new IntersectionObserver(function (entradas) {
        if (!entradas[0] || !entradas[0].isIntersecting) return;
        carga();
        abreDecoder();
        sigue();
      }, { rootMargin: "80px 0px" });
      vista.observe(pista);
    } else {
      carga();
    }

    window.addEventListener("scroll", function () {
      if (!cargado) return;
      abreDecoder();
      sigue();
    }, { passive: true });
    window.addEventListener("wheel", function () {
      if (!cargado) return;
      abreDecoder();
      sigue();
    }, { passive: true });
    window.addEventListener("touchstart", function () {
      if (!cargado) return;
      abreDecoder();
      sigue();
    }, { passive: true });
    window.addEventListener("resize", function () {
      if (cargado) sigue();
    });
  }

  function arrancaTodo() {
    document.querySelectorAll("[data-ak-scroll]").forEach(arranca);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", arrancaTodo);
  } else {
    arrancaTodo();
  }
})();
